import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class AudienceUsersStateModel extends PaginatedSubentityStateModel {
    constructor() {
        super('AudienceUsersStateModel');
    }
}
